import { render, staticRenderFns } from "./DateOfBirth.vue?vue&type=template&id=7b8af642&scoped=true&"
import script from "./DateOfBirth.vue?vue&type=script&lang=js&"
export * from "./DateOfBirth.vue?vue&type=script&lang=js&"
import style0 from "./DateOfBirth.vue?vue&type=style&index=0&id=7b8af642&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8af642",
  null
  
)

export default component.exports